module.exports = global["jQuery"] = require("-!/code/node_modules/expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/dist/jquery.js-exposed
// module id = 144
// module chunks = 19 21